import { cva } from 'class-variance-authority';

export const cvaRoot = cva(
  ['Availability-cvaRoot', 'inline-flex items-center gap-0.4', 'text-bodyM !font-semibold whitespace-nowrap'],
  {
    variants: {
      color: {
        green: 'text-cMediumGreen',
        red: 'text-cRed',
        yellow: 'text-cExtraOrange',
        gray: 'text-cBlack text-opacity-[0.48]',
      },
    },
    defaultVariants: {
      color: 'green',
    },
  }
);

export const cvaIcon = cva(['Availability-cvaIcon', 'w-1.6 h-1.6', 'rotate-[45deg]']);

export const cvaNotAllowed = cva([
  'AvailabilityStyles-cvaNotAllowed',
  'w-1.6 h-1.6',
  // '-rotate-[45deg]'
]);
